// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-preview-document[data-v-10cb3830]{position:absolute;left:0;top:50px;height:100%;min-height:calc(100vh - 50px - var(--admin-bar-height, 0px));min-width:100vw;width:100%}.step-preview-document iframe[data-v-10cb3830]{height:100%;width:100%}.loading-content[data-v-10cb3830]{background:50%/100px no-repeat url(/wp-content/themes/snappy-theme/assets/images/loading2.gif)}", ""]);
// Exports
module.exports = exports;
